/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Enum of all feature flags in the system.

Boolean flags can be enabled or disabled per organization; value flags hold a
float in [0, 1] per organization. Add new flags here with a descriptive name and
register each flag in exactly ONE of FEATURE_FLAG_DEFAULTS (boolean flags) or
FEATURE_FLAG_VALUE_DEFAULTS (float value flags) — never both.
 */
export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureFlag = {
  carerix_ats_enabled: 'carerix_ats_enabled',
  oracle_ats_enabled: 'oracle_ats_enabled',
  example_feature: 'example_feature',
  example_value_feature: 'example_value_feature',
  sourcing_submittal_filter: 'sourcing_submittal_filter',
  enhanced_texting_prompting: 'enhanced_texting_prompting',
  a2p_10dlc_enabled: 'a2p_10dlc_enabled',
  sourcing_settings: 'sourcing_settings',
  client_billing_page_visible: 'client_billing_page_visible',
  meeting_notes_access: 'meeting_notes_access',
  sso_identity_linking_strict: 'sso_identity_linking_strict',
  teams_notifications: 'teams_notifications',
  sourcing_note_filter: 'sourcing_note_filter',
  sms_disabled: 'sms_disabled',
  blindspots_cheating_detection: 'blindspots_cheating_detection',
  reverse_sourcing_enabled: 'reverse_sourcing_enabled',
  gemini_vertex_dedicated_routing: 'gemini_vertex_dedicated_routing',
  gemini_call_demo: 'gemini_call_demo',
  screening_decision_interpreter: 'screening_decision_interpreter',
  surge_follow_up_call_enabled: 'surge_follow_up_call_enabled',
  surge_tempworks_placement_call_enabled:
    'surge_tempworks_placement_call_enabled',
  sync_queue_backlog_admission: 'sync_queue_backlog_admission',
  breezy_use_direct_api: 'breezy_use_direct_api',
  proxied_recording_playback: 'proxied_recording_playback',
  cekura_org_inbound_routing: 'cekura_org_inbound_routing',
  assume_sms_consent: 'assume_sms_consent',
  demo_meeting_copilot: 'demo_meeting_copilot',
  ats_stage_routing_rules: 'ats_stage_routing_rules',
  ats_post_call_delivery_shadow: 'ats_post_call_delivery_shadow',
  ats_post_call_delivery_enabled: 'ats_post_call_delivery_enabled',
  on_call_sms_consent: 'on_call_sms_consent',
  meeting_copilot_content_gate: 'meeting_copilot_content_gate',
  cross_org_fraud_matching: 'cross_org_fraud_matching',
  ai_resume_review_only_setting: 'ai_resume_review_only_setting',
  is_staffing: 'is_staffing',
  meeting_copilot_staffing_discovery: 'meeting_copilot_staffing_discovery',
  rejoin_orchestrator_shadow: 'rejoin_orchestrator_shadow',
  score_sourced_candidates: 'score_sourced_candidates',
  use_google_single_email_v2_oauth: 'use_google_single_email_v2_oauth',
  adding_candidates_disabled: 'adding_candidates_disabled',
  azure_video_call_processor: 'azure_video_call_processor',
  whatsapp_embedded_signup: 'whatsapp_embedded_signup',
  alerts_page: 'alerts_page',
  external_agent: 'external_agent',
  tenzo_advertise_in_feedback: 'tenzo_advertise_in_feedback',
  submittal_share_links: 'submittal_share_links',
  whats_new: 'whats_new',
  sourcing_cross_language_expansion: 'sourcing_cross_language_expansion',
} as const;
